import { Container, Grid, Link, Typography } from '@mui/material'
import * as React from 'react'
import Box from '@mui/material/Box'
import { FOOTER_1_URLS, FOOTER_2_URLS, WWW_BASE_URL } from '../../../App'

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        // position: 'fixed',
        // bottom: 0,
        // width: '100%',
        // zIndex: 9999,
        backgroundColor: 'text.secondary',
        color: 'white',
        p: 2,
        textAlign: 'center'
      }}
    >

      <Container maxWidth={'lg'} sx={{ px: 0 }}>
        <Grid container>
          <Grid item md={3} xs={12} sx={{ display: 'flex' }} alignItems={'start'} flexDirection={'column'}>
            <Link href={WWW_BASE_URL}>
              <Box component={'img'} sx={{ py: 0, width: 200 }}
                   className="brand-logo" src="/icons/Sun-Exchange-White-Orange.png" alt="Sun Exchange Alternate Logo"/>
            </Link>
          </Grid>

          <Grid item md={3} xs={12} sx={{ display: 'flex' }} alignItems={'start'} flexDirection={'column'}>
            {FOOTER_1_URLS.map((page) => (
              <Link href={page.url} key={page.id}
                    target="_blank"
                    color={'primary.contrastText'}
                    underline={'hover'}
                    variant={'body1'}
                    sx={{ px: 2, display: 'block' }}>
                {page.title}
              </Link>
            ))}
          </Grid>

          <Grid item md={3} xs={12} sx={{ display: 'flex', mb: 3 }} alignItems={'start'} flexDirection={'column'}>
            {FOOTER_2_URLS.map((page) => (
              <Link href={page.url} key={page.id}
                    target="_blank"
                    color={'primary.contrastText'}
                    underline={'hover'}
                    variant={'body1'}
                    sx={{ px: 2 }}>
                {page.title}
              </Link>
            ))}
          </Grid>

          <Grid item md={3} xs={12} >
            <Box sx={{ display: 'flex' }} alignItems={'start'} flexDirection={'column'}>
              <Typography variant={'body1'} textAlign={'left'}>For general inquiries contact us:</Typography>
              <Link href={'mailto:hello@thesunexchange.com'}
                    color={'primary.contrastText'}
                    underline={'hover'}
                    variant={'body1'}
                    sx={{ }}>
                hello@thesunexchange.com
              </Link>
            </Box>
          </Grid>

          <Grid item md={6} textAlign={'left'} sx={{ pt: 2 }}>
            <Typography variant={'caption'}>© 2024 The Sun Exchange | All rights reserved.</Typography>
          </Grid>

          <Grid item md={6} textAlign={'right'} sx={{ pt: 2 }}>
            <Typography variant={'caption'} sx={{ fontSize: '10px' }}>11091</Typography>
          </Grid>

        </Grid>
      </Container>

    </Box>
  )
}

export default Footer
